import React, { useMemo, useState } from "react";
import moment from "moment";
import Modal from "react-responsive-modal";
import { Link } from "react-router-dom";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../Utils/renderField/renderReadField";
import { VaciadosCell } from "./VaciadosCell";
import NullableValue from "../../../Utils/renderField/nullableValue";
import { buildResumenMateriaPrima } from "../helpers/groupProductos";

export const ModalIngresos = ({ opened, onClose, trasladoSeleccionado }) => {
    const [modoResumen, setModoResumen] = useState(true);

    const listaRecepciones = trasladoSeleccionado
        ? trasladoSeleccionado.detalles
        : [];

    const resumenRecepciones = useMemo(() => {
        if (!listaRecepciones) return [];

        return buildResumenMateriaPrima(listaRecepciones, trasladoSeleccionado);
    }, [listaRecepciones, trasladoSeleccionado]);

    const FilaTotales = (
        <tr className="modal-ingresos__totales-row">
            <td
                className="text-right text-nowrap"
                colSpan={modoResumen ? 2 : 5}
            >
                <strong>TOTALES:</strong>
            </td>
            <td className="text-center text-nowrap">
                {/* TOTAL DE KG HÚMEDOS */}
                <RenderKilogramo
                    value={listaRecepciones.reduce(
                        (total, detalle) =>
                            total + (detalle.kilos_humedos || 0),
                        0,
                    )}
                    decimalScale={2}
                />
            </td>
            {!modoResumen && <td></td>}
            <td className="text-center text-nowrap">
                {/* TOTAL DE KG SECOS */}
                <RenderKilogramo
                    value={listaRecepciones.reduce(
                        (total, detalle) =>
                            total + (detalle.kilos_secos_laboratorio || 0),
                        0,
                    )}
                    decimalScale={3}
                />
            </td>
            {modoResumen && (
                <td className="text-center text-nowrap cell-border-left">
                    {/* TOTAL DE PESOS REALES */}
                    <RenderKilogramo
                        value={resumenRecepciones.reduce(
                            (total, detalle) =>
                                total +
                                ((detalle.pesaje && detalle.pesaje.peso_neto) ||
                                    0),
                            0,
                        )}
                        decimalScale={3}
                    />
                </td>
            )}
        </tr>
    );

    const TablaDetalle = (
        <div className="new-table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ID RECEPCIÓN</th>
                        <th>FECHA DE RECEPCIÓN</th>
                        <th>FINCA</th>
                        <th>MATERIA PRIMA</th>
                        <th>ALMACENES</th>
                        <th>KILOS HÚMEDOS</th>
                        <th>DRC LABORATORIO</th>
                        <th className="table__min-width-cell">
                            KILOS SECOS LAB
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {trasladoSeleccionado.detalles.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center">
                                    {item.id_ingreso}
                                </td>
                                <td className="text-center text-nowrap">
                                    {moment(item.fecha_entrada).format(
                                        "DD/MM/YYYY HH:mm:ss",
                                    )}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.finca ? item.finca.nombre : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.materia_prima
                                        ? item.materia_prima.nombre
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    <VaciadosCell productos={item.productos} />
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.kilos_humedos}>
                                        <RenderKilogramo
                                            value={item.kilos_humedos}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.drc_laboratorio}>
                                        <RenderNumberPercentage
                                            value={item.drc_laboratorio}
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.kilos_secos_laboratorio}
                                    >
                                        <RenderKilogramo
                                            value={item.kilos_secos_laboratorio}
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                    {FilaTotales}
                </tbody>
            </table>
        </div>
    );

    const TablaResumen = (
        <div className="new-table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>RECEPCIONES</th>
                        <th>MATERIA PRIMA</th>
                        <th>KILOS HÚMEDOS</th>
                        <th>KILOS SECOS LAB</th>
                        <th className="cell-border-left">PESO NETO REAL</th>
                    </tr>
                </thead>
                <tbody>
                    {resumenRecepciones.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center text-nowrap pesaje-traslado__table-ellipsis-cell">
                                    {item.ingresos_ids_concat}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.materia_prima
                                        ? item.materia_prima.nombre
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.kilos_humedos}>
                                        <RenderKilogramo
                                            value={item.kilos_humedos}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.kilos_secos_laboratorio}
                                    >
                                        <RenderKilogramo
                                            value={item.kilos_secos_laboratorio}
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap cell-border-left">
                                    {item.yaPesado ? (
                                        <RenderKilogramo
                                            value={item.pesaje.peso_neto}
                                        />
                                    ) : (
                                        "—"
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                    {FilaTotales}
                </tbody>
            </table>
        </div>
    );

    return (
        <Modal
            open={opened}
            onClose={onClose}
            styles={{ modal: { minWidth: "75vw" } }}
        >
            <div className="pb-2 titulo-modal d-flex justify-content-center">
                <h2>Detalle de traslado</h2>
            </div>

            <div className="formulario-fields-row">
                <div className="formulario-field">
                    <label className="text-nowrap text-center">
                        Número de traslado
                    </label>
                    <span className="text-nowrap text-center">
                        {trasladoSeleccionado.numero}
                    </span>
                </div>
                <div className="formulario-field">
                    <label className="text-nowrap text-center">Origen</label>
                    <span className="text-nowrap text-center">
                        {trasladoSeleccionado.acopio_origen
                            ? trasladoSeleccionado.acopio_origen.nombre
                            : ""}
                    </span>
                </div>
                <div className="formulario-field">
                    <label className="text-nowrap text-center">Destino</label>
                    <span className="text-nowrap text-center">
                        {trasladoSeleccionado.acopio_destino
                            ? trasladoSeleccionado.acopio_destino.nombre
                            : ""}
                    </span>
                </div>
                <div className="formulario-field">
                    <label className="text-nowrap text-center">
                        Fecha de envío
                    </label>
                    <span className="text-nowrap text-center">
                        {moment(trasladoSeleccionado.fecha_salida).format(
                            "DD/MM/YYYY HH:mm:ss",
                        )}
                    </span>
                </div>
                {trasladoSeleccionado.fecha_entrega && (
                    <div className="formulario-field">
                        <label className="text-nowrap text-center">
                            Fecha de entrega
                        </label>
                        <span className="text-nowrap text-center">
                            {moment(trasladoSeleccionado.fecha_entrega).format(
                                "DD/MM/YYYY HH:mm:ss",
                            )}
                        </span>
                    </div>
                )}
                <div className="formulario-field">
                    <label className="text-nowrap text-center">Piloto</label>
                    <span className="text-nowrap text-center">
                        {trasladoSeleccionado.piloto
                            ? trasladoSeleccionado.piloto.nombre
                            : "-"}
                    </span>
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap text-center">
                        Peso de salida
                    </label>
                    <span className="text-nowrap text-center">
                        {trasladoSeleccionado.peso_salida ? (
                            <RenderKilogramo
                                value={trasladoSeleccionado.peso_salida}
                                decimalScale={3}
                            />
                        ) : (
                            "Pendiente"
                        )}
                    </span>
                </div>
            </div>

            <div className="pb-2 pl-2 d-flex justify-content-between">
                <h5>Recepciones</h5>
                <span
                    className="btn-link-pointer"
                    onClick={() => setModoResumen(!modoResumen)}
                >
                    {modoResumen ? "Mostrar detalle" : "Mostrar resumen"}
                </span>
            </div>

            {modoResumen ? TablaResumen : TablaDetalle}

            <div className="d-flex justify-content-center mt-3">
                <Link
                    to={`traslados/${trasladoSeleccionado.id}/ver-boleta`}
                    className="px-2"
                >
                    <button className="btn btn-secondary">
                        Ver boleta de traslado
                    </button>
                </Link>
            </div>
        </Modal>
    );
};
